import { createSelector } from 'reselect'

import RootState from '../types'
import { ListingSectionObject } from '../../transports/common/listing-section-transport'
import { BULK_INQUIRY } from '../../constants/search-result-listing'

const getSelectedListingsMap = (state: RootState): Record<string, ListingSectionObject> =>
    state.bulkInquiry.selectedListings

const getSelectionOrder = (state: RootState): string[] => state.bulkInquiry.selectionOrder

export const getSelectedListings = createSelector(
    getSelectedListingsMap,
    getSelectionOrder,
    (selectedListings, selectionOrder): ListingSectionObject[] =>
        selectionOrder.map(id => selectedListings[id]).filter((listing): listing is ListingSectionObject => !!listing),
)

export const getSelectedCount = createSelector(
    getSelectedListingsMap,
    (selectedListings): number => Object.keys(selectedListings).length,
)

export const getIsListingSelected = (id: string | number) =>
    createSelector(getSelectedListingsMap, (selectedListings): boolean => Boolean(selectedListings[String(id)]))

export const getCanCompare = createSelector(
    getSelectedCount,
    (count): boolean => count >= BULK_INQUIRY.MIN_SELECTION_FOR_COMPARE,
)

export const getIsSelectionFull = createSelector(
    getSelectedCount,
    (count): boolean => count >= BULK_INQUIRY.MAX_SELECTION,
)

export const getIsSelectMode = createSelector(
    (state: RootState) => state.bulkInquiry.isSelectMode,
    (isSelectMode): boolean => isSelectMode,
)

export const getIsBulkInquirySliceRehydrated = createSelector(
    (state: RootState) => (state.bulkInquiry as unknown as { _persist?: { rehydrated?: boolean } })._persist,
    (persist): boolean => !!persist?.rehydrated,
)
